<template>
  <div class="nav-container">
    <!-- 页眉区 -->
    <div class="header">
      <h1>🌐 网址导航</h1>
      <p>精选实用站点 · 点击名称一键直达</p>
    </div>

    <!-- 工具栏 -->
    <div class="toolbar">
      <div class="stats">
        <el-icon><Collection /></el-icon>
        <span @click="fanhuishouye">返回首页</span>
      </div>
      <div class="search-wrapper">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索网站名称或网址..."
          :prefix-icon="Search"
          clearable
          size="large"
          class="search-input"
          @clear="handleClearSearch"
        />
      </div>
    </div>

    <!-- 网址网格 -->
    <div class="links-grid" v-if="filteredSites.length > 0">
      <el-card
        @click="tioazhaunlink(site.url)"
        v-for="site in filteredSites"
        :key="site.url"
        class="link-card"
        shadow="hover"
        body-style="{ padding: '0px' }"
      >
        <div class="link-content">
          <div class="site-info">
            <a
              :href="'javascript:;'"
              class="site-name"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ site.name }}
            </a>
            <div class="site-url-mini">{{ getShortUrl(site.url) }}</div>
          </div>
          <el-icon class="visit-icon"><Right /></el-icon>
        </div>
      </el-card>
    </div>

    <!-- 无结果状态 -->
    <el-empty
      v-else
      description="没有找到相关网站，试试其他关键词～"
      :image-size="120"
      class="empty-state"
    />

    <!-- 页脚 -->
    <div class="footer">
      <span>✨ 安全外链导航 | 共收录优质站点 · 点击名称直接跳转</span>
    </div>
  </div>
</template>

<script setup>
import { post, get } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, ref ,computed} from "vue";
import { Search, Right, Collection } from '@element-plus/icons-vue'
import { useRouter } from "vue-router";

const router = useRouter();

//返回
const fanhuishouye=()=>{
  router.push({
    path: "/",
    query: {},
  });
}
//
const tioazhaunlink=url=>{
  window.open(url)
}

// 网址数据 (共50条)
const sitesData = ref([
  { name: "创意通", url: "http://cyt.yuanpingjia.com.cn/" },
  { name: "教改与创新", url: "http://jgycx.yuanpingjia.com.cn/" },
  { name: "科研成果与传播", url: "http://kycg.yuanpingjia.com.cn/" },
  { name: "青年教师教研", url: "http://qnjsjy.yuanpingjia.com.cn/" },
])

// 搜索关键词
const searchKeyword = ref('')

// 过滤后的站点
const filteredSites = computed(() => {
  if (!searchKeyword.value.trim()) {
    return sitesData.value
  }
  const keyword = searchKeyword.value.toLowerCase().trim()
  return sitesData.value.filter(site =>
    site.name.toLowerCase().includes(keyword) ||
    site.url.toLowerCase().includes(keyword)
  )
})

// 获取短域名用于显示
const getShortUrl = (url) => {
  try {
    const urlObj = new URL(url)
    return urlObj.hostname.replace(/^www\./, '')
  } catch {
    return url.length > 35 ? url.substring(0, 32) + '...' : url
  }
}

// 清除搜索
const handleClearSearch = () => {
  searchKeyword.value = ''
}

</script>

<style scoped>
 .nav-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2px);
  border-radius: 2rem;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

/* 页眉 */
.header {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  padding: 1.8rem 2rem 1.5rem;
  border-bottom: 1px solid rgba(100, 108, 118, 0.2);
  text-align: center;
}

.header h1 {
  font-size: 2.2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1f2b3c, #2c3e50);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  letter-spacing: -0.3px;
  margin-bottom: 0.5rem;
}

.header p {
  color: #4b5565;
  font-size: 0.95rem;
  margin-top: 0.25rem;
}

/* 工具栏 */
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.stats {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #eef2f6;
  padding: 0.35rem 1rem;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #1e2a3e;
  cursor: pointer;
}


.stats span {
  font-weight: 700;
  color: #0f3b5c;
}

.search-wrapper {
  width: 280px;
}

.search-input {
  :deep(.el-input__wrapper) {
    border-radius: 48px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    background: white;
  }
}

/* 网址网格 */
.links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.8);
}

.link-card {
  transition: all 0.25s ease-in-out;
  border-radius: 1rem;
  cursor: pointer;
}

.link-card:hover {
  transform: translateY(-3px);
}

.link-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1.2rem;
  gap: 0.5rem;
}

.site-info {
  flex: 1;
  min-width: 0;
}

.site-name {
  font-size: 1rem;
  font-weight: 600;
  color: #1f3a4b;
  text-decoration: none;
  display: inline-block;
  transition: color 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.site-name:hover {
  color: #2c7cb6;
  text-decoration: underline;
}

.site-url-mini {
  font-size: 0.7rem;
  color: #7f8c8d;
  margin-top: 0.2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.visit-icon {
  color: #90a4bc;
  transition: all 0.2s;
  flex-shrink: 0;
  font-size: 1rem;
}

.link-card:hover .visit-icon {
  color: #2c7cb6;
  transform: translateX(2px);
}

/* 空状态 */
.empty-state {
  padding: 3rem 2rem;
  background: rgba(255, 255, 255, 0.8);
}

/* 页脚 */
.footer {
  background: #f1f5f9;
  padding: 1rem 2rem;
  text-align: center;
  font-size: 0.75rem;
  color: #5c6e82;
  border-top: 1px solid #e2edf2;
}

/* 响应式 */
@media (max-width: 768px) {
  .nav-container {
    border-radius: 1rem;
  }

  .header h1 {
    font-size: 1.6rem;
  }

  .toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .search-wrapper {
    width: 100%;
  }

  .links-grid {
    padding: 1rem;
    gap: 0.75rem;
    grid-template-columns: 1fr;
  }

  .link-content {
    padding: 0.7rem 1rem;
  }
}

/* 滚动条样式 */
:deep(.el-scrollbar__thumb) {
  background-color: #b9cadb;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #e9eef3;
  border-radius: 8px;
}

::-webkit-scrollbar-thumb {
  background: #b9cadb;
  border-radius: 8px;
}
</style>
